import * as types from './constants';

// Update Lookbook Published
export const updateLookbookPublishedRequest = data => (
  { type: types.UPDATE_LOOKBOOK_PUBLISHED_REQUEST, payload: data }
);

export const updateLookbookPublishedDone = data => (
  { type: types.UPDATE_LOOKBOOK_PUBLISHED_DONE, payload: data }
);

export const updateLookbookPublishedFailed = errors => (
  { type: types.UPDATE_LOOKBOOK_PUBLISHED_FAILED, payload: errors }
);

export const updateLookbookPublishedClearErrors = prop => (
  { type: types.UPDATE_LOOKBOOK_PUBLISHED_CLEAR_ERRORS, payload: prop }
);

export const updateLookbookPublishedReset = () => (
  { type: types.UPDATE_LOOKBOOK_PUBLISHED_RESET }
);